<section class="">
  <div class="container py-0">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb mb-0 bg-transparent">
        <li class="breadcrumb-item" routerLinkActive="active"><a class="text-dark" [routerLink]="['/']">Home</a>
        </li>
        <li *ngIf="cmsPage && cmsPage.parentCmsPage && cmsPage.parentCmsPage.parentCmsPage" class="breadcrumb-item"
          routerLinkActive="active">
          <a class="text-dark"
            [routerLink]="['/page/' + cmsPage.parentCmsPage.parentCmsPage.slug]">{{ cmsPage.parentCmsPage.parentCmsPage.title }}
          </a>
        </li>
        <li *ngIf="cmsPage && cmsPage.parentCmsPage" class="breadcrumb-item" routerLinkActive="active">
          <a class="text-dark" [routerLink]="['/page/' + cmsPage.parentCmsPage.slug]">{{ cmsPage.parentCmsPage.title }}
          </a>
        </li>
        <li *ngIf="cmsPage" class="breadcrumb-item" routerLinkActive="active">
          <a class="text-dark" [routerLink]="['/page/' + cmsPage.slug]">
            {{cmsPage.title}}
          </a>
        </li>
      </ol>
    </nav>
  </div>
</section>
